export { default } from './load-appearance-in-browser';
